module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/athor27-d33d1ab77ea37e471c24f2058ddce945.jpg";